import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Link, Switch, Route } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Dropdown, Menu, Badge } from 'antd'

import { AiOutlineDown } from 'react-icons/ai'
import { FaHandHolding } from 'react-icons/fa'

import RecordSpoilage from '../modals/recordspoilage'
import ModifyQuantity from '../modals/modifyquantity'
import RestockItem from '../modals/restockitem'
import RestockOpen from '../modals/restockOpen'
import DispenseItems from '../modals/dispenseItems'
import Receive from '../reusable/receive'
import EditInventoryItem from '../modals/editInventoryItem'
import ItemHistory from '../drawers/itemHistory'
import Movement from '../drawers/movement'
import ItemRequests from '../drawers/itemRequests'
import SelfIssue from '../modals/selfIssue'
import Returns from '../modals/returns'

import { useToggle, useListData, usePet, useSocketEvents, useShift } from '../../modules'
import { removeAccItem } from '../../store/actions'
import Batches from '../modals/batches'

const Inventory = ({ requireShift, department, path, storeName }) => {
    const { user, shift, params, lastInventoryAlert } = useSelector(state => state.application)
    const { queue } = useSelector(state => state.accounting)

    const dispatch = useDispatch()

    const [Shifts, ShiftsModal] = useShift(department)

    const [selected, setSelected] = useState(null)
    const [string, setString] = useState('')
    const [store, setStore] = useState()
    const [requests, setRequests] = useState(0)
    const [lowStockItemIds, setLowStockItemIds] = useState([])
    const [nearExpiryItemIds, setNearExpiryItemIds] = useState([])

    // const { option, setOption, dropdown } = useDropDown(['Select', 'Delete', 'Renew'])

    const [restockModal, toggleRestockModal] = useToggle()
    const [modifyQuantityModal, toggleModifyQuantityModal] = useToggle()
    const [inventoryItemModal, toggleInventoryItemModal] = useToggle()
    const [spoilageModal, toggleSpoilageModal] = useToggle()
    const [dispenseModal, toggleDispenseModal] = useToggle()
    const [invEdit, toggleInvEdit] = useToggle()
    const [self, toggleSelf] = useToggle()
    const [batches, toggleBatches] = useToggle()
    const [returnsModal, toggleReturnsModal] = useToggle()
    const [selectMode] = useToggle(queue.length > 0)

    const restock = itm => {
        setSelected(itm)
        toggleRestockModal()
    }

    const spoilage = itm => {
        setSelected(itm)
        toggleSpoilageModal()
    }

    const modifyQty = itm => {
        setSelected(itm)
        toggleModifyQuantityModal()
    }

    const returns = itm => {
        setSelected(itm)
        toggleReturnsModal()        
    }

    const edit = itm => {
        setSelected(itm)
        toggleInvEdit()
    }

    const issueToSelf = rec => {
        setSelected(rec)
        toggleSelf()
    }

    const viewBatches = rec => {
        setSelected(rec)
        toggleBatches()
    }

    const chooseItem = itm => {
        let i = queue.findIndex(e => e.item._id === itm.item._id)
        if (i >= 0) {
            dispatch(removeAccItem(i))
        } else {
            setSelected(itm)
        }
    }

    const [, getRequests] = usePet('requestsByStore', { store: store?._id, type: "Received", classif: 'Pending' }, { notify: true, manual: true, callback: ({ data }) => setRequests(data.count) })
    const [, getLowStockItems] = usePet('criticalItems', { store: store?._id, limit: 500 }, {
        notify: false,
        manual: true,
        callback: ({ data }) => setLowStockItemIds((data?.items ?? []).map(item => item?.item?._id).filter(Boolean))
    })
    const [, getNearExpiryItems] = usePet('nearExpiryItems', {
        store: store?._id,
        thresholdDays: params?.inventoryNearExpiryThresholds?.[0] ?? 30,
        limit: 500
    }, {
        notify: false,
        manual: true,
        callback: ({ data }) => setNearExpiryItemIds((data?.items ?? []).map(item => item?.item?._id).filter(Boolean))
    })

    const [
        { loading: invLoading, error: invError, fetch },
        { list: inventory = [] },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('inventory', {
        store: store?._id,
        string
    }, { notify: true, manual: true })

    const refresh = () => {
        fetch()
        getRequests()
        getLowStockItems()
        getNearExpiryItems()
        navigate(1)
    }

    usePet('getStoreId', { name: storeName }, {
        notify: true, callback: ({ data }) => {
            if (data) {
                setStore(data)
                setTimeout(refresh, 200)
            }
        }
    })

    useSocketEvents({
        'new-request': {
            condition: data => data.store === store?.name,
            notif: {
                message: 'New Request',
                type: 'info'
            },
            callback: getRequests
        }
    })

    useEffect(() => {
        if (!store?._id || !lastInventoryAlert) return
        if (lastInventoryAlert.storeId !== store._id && lastInventoryAlert.destination !== store?.name) return
        getLowStockItems()
        getNearExpiryItems()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lastInventoryAlert, store?._id, store?.name, params?.inventoryNearExpiryThresholds])

    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0)
            refresh()
    }

    const shiftOK = !(requireShift && !shift)

    let override = store?.permissions?.includes('*') || user?.issuperuser

    const nearExpiryThresholdDays = params?.inventoryNearExpiryThresholds?.[0] ?? 30

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <ModifyQuantity
                store={store}
                onPerform={fetch}
                record={selected}
                toggle={toggleModifyQuantityModal}
                visible={modifyQuantityModal} />
            <RestockOpen
                store={store}
                onPerform={fetch}
                toggle={toggleInventoryItemModal}
                visible={inventoryItemModal} />
            <RestockItem
                store={store}
                onPerform={fetch}
                record={selected}
                toggle={toggleRestockModal}
                visible={restockModal} />
            <RecordSpoilage
                store={store}
                onPerform={fetch}
                record={selected}
                toggle={toggleSpoilageModal}
                visible={spoilageModal} />
            <DispenseItems
                store={store}
                onPerform={fetch}
                toggle={toggleDispenseModal}
                visible={dispenseModal} />
            <Returns
                store={store}
                onPerform={fetch}
                record={ selected }
                toggle={toggleReturnsModal}
                visible={returnsModal} />
            {
                invEdit &&
                <EditInventoryItem
                    onPerform={fetch}
                    item={selected?.item}
                    toggle={toggleInvEdit}
                    visible={invEdit} />
            }
            {
                batches &&
                <Batches
                    rec={ selected }
                    toggle={toggleBatches }
                    visible={ batches } />
            }
            <SelfIssue
                store={store}
                onPerform={fetch}
                record={ selected }
                toggle={toggleSelf}
                visible={self} />
            <div className="w-full mx-auto">
                <div className="flex justify-between items-center mb-8">
                    <input
                        onChange={e => search(e.target.value)}
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-inv-item"
                        type="text"
                        placeholder="Type to search items" />
                    { requireShift && <Shifts /> }
                </div>
                { requireShift && ShiftsModal }
                <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                    <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                        <h2 className="font-semibold text-gray-800">Inventory</h2>
                        <span className='flex'>
                            {
                                (shiftOK && (override || user.stations?.some(st => st.name === 'store' && (st.permissions.includes('edit-items') || st.permissions.includes('*'))))) &&
                                <button onClick={() => toggleInventoryItemModal()} className="btn mr-2 hisani-btn-green-light text-white">
                                    <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                                        <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                    </svg>
                                    <span className="hidden xs:block ml-2">Add Item</span>
                                </button>
                            }
                            {
                                (shiftOK && (store?.permissions?.includes('handle-requests') || override)) &&
                                <Badge count={requests}>
                                    <Link to={`${path}/requests/${store?._id}`}>
                                        <button className="btn flex items-center mr-2 hisani-btn-green-light text-white">
                                            <FaHandHolding />
                                            <span className="hidden xs:block ml-2">Requests</span>
                                        </button>
                                    </Link>
                                </Badge>
                            }
                        </span>
                    </header>
                    <div className="p-3">
                        <Receive
                            error={invError}
                            loading={invLoading}
                            progress>
                            {
                                store ?
                                    <div className="overflow-x-auto">
                                        <Receive
                                            error={invError}
                                            loading={invLoading}
                                            progress>
                                            {
                                                inventory?.length > 0 ?
                                                    <table className="table-auto w-full">
                                                        {/* Table header */}
                                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                            <tr>
                                                                <th className="p-2">
                                                                    <div className="font-semibold text-center">No</div>
                                                                </th>
                                                                <th className="p-2">
                                                                    <div className="font-semibold text-left">Item</div>
                                                                </th>
                                                                <th className="p-2">
                                                                    <div className="font-semibold text-center">Category</div>
                                                                </th>
                                                                <th className="p-2">
                                                                    <div className="font-semibold text-center">Quantity</div>
                                                                </th>
                                                                <th className="p-2">
                                                                    <div className="font-semibold text-center"></div>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        {/* Table body */}
                                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                            {
                                                                inventory.map((rec, key) => {
                                                                    const isLowStock = lowStockItemIds.includes(rec?.item?._id)
                                                                    const hasNearExpiry = nearExpiryItemIds.includes(rec?.item?._id)
                                                                    const earliestExpiry = rec?.variations
                                                                        ?.map(variant => variant?.expiry)
                                                                        ?.filter(Boolean)
                                                                        ?.sort((a, b) => new Date(a) - new Date(b))?.[0]

                                                                    return (
                                                                    <tr key={rec?.item?._id}>
                                                                        <td className="p-2">
                                                                            <div className="text-center">
                                                                                {
                                                                                    selectMode ?
                                                                                        <input
                                                                                            onChange={() => chooseItem(rec)}
                                                                                            checked={queue.some(e => e.item._id === rec.item._id)}
                                                                                            type="checkbox"
                                                                                            className="form-checkbox cursor-pointer h-5 w-5" />
                                                                                        :
                                                                                        `${((page - 1) * limit) + key + 1}.`
                                                                                }
                                                                            </div>
                                                                        </td>
                                                                        <td className="p-2">
                                                                            <div className="">{rec.item.name}</div>
                                                                            {
                                                                                rec?.item?.code &&
                                                                                <p className="text-gray-500 text-xs italic">{rec?.item?.code}</p>
                                                                            }
                                                                            <div className="mt-1 flex flex-wrap gap-1">
                                                                                {
                                                                                    isLowStock &&
                                                                                    <span className="inline-flex px-2 py-1 rounded-full text-[10px] font-semibold bg-red-100 text-red-700">Low stock</span>
                                                                                }
                                                                                {
                                                                                    hasNearExpiry &&
                                                                                    <span className="inline-flex px-2 py-1 rounded-full text-[10px] font-semibold bg-amber-100 text-amber-700">
                                                                                        Near expiry
                                                                                    </span>
                                                                                }
                                                                            </div>
                                                                        </td>
                                                                        <td className="p-2">
                                                                            <div className="text-center">{rec.item.category}</div>
                                                                        </td>
                                                                        <td className="p-2">
                                                                            <div className="text-center">{rec.variations.reduce((total, variant) => total + variant.total, 0)} {rec.item.issuedIn}</div>
                                                                            {
                                                                                earliestExpiry &&
                                                                                <p className="text-[11px] text-gray-500 italic text-center">
                                                                                    Earliest expiry {moment(earliestExpiry).format('DD MMM YYYY')}
                                                                                    {hasNearExpiry ? ` · within ${nearExpiryThresholdDays} day(s)` : ''}
                                                                                </p>
                                                                            }
                                                                        </td>
                                                                        <td className="p-2 text-center">
                                                                            <Dropdown
                                                                                overlay={
                                                                                    <Menu>
                                                                                        {
                                                                                            (user.stations?.some(st => st.name === 'store' && (st.permissions.includes('edit-items') || st.permissions.includes('*'))) && override) &&
                                                                                            <Menu.Item onClick={ () => edit(rec) }>View</Menu.Item>
                                                                                        }
                                                                                        {
                                                                                            (user.stations?.some(st => st.name === 'store' && (st.permissions.includes('view-available-batches') || st.permissions.includes('*'))) && override) &&
                                                                                            <Menu.Item onClick={ () => viewBatches(rec) }>Available Batches</Menu.Item>
                                                                                        }
                                                                                        {
                                                                                            shiftOK ?
                                                                                            <>
                                                                                                {
                                                                                                    (store?.permissions?.includes('restock-items') || override) &&
                                                                                                    <Menu.Item onClick={ () => restock(rec) }>Restock Item</Menu.Item>
                                                                                                }
                                                                                                {
                                                                                                    (store?.permissions?.includes('move-stock') || override) &&
                                                                                                    <Menu.Item onClick={ () => restock(rec) }>Move to Another Store</Menu.Item>
                                                                                                }
                                                                                                {
                                                                                                    (store?.permissions?.includes('modify-quantity') || override) &&
                                                                                                    <Menu.Item onClick={ () => modifyQty(rec)}>Modify Quantity</Menu.Item>
                                                                                                }
                                                                                                {
                                                                                                    (store?.permissions?.includes('view-history') || override) &&
                                                                                                    <Link className="text-gray-600 hover:text-gray-600" to={`${path}/history/${rec?.item?._id}/${store?._id}`}><Menu.Item>View History</Menu.Item></Link>
                                                                                                }
                                                                                                {
                                                                                                    (store?.permissions?.includes('view-movement') || override) &&
                                                                                                    <Link className="text-gray-600 hover:text-gray-600" to={`${path}/movement/${rec?.item?._id}/${store?._id}`}><Menu.Item>View Movement</Menu.Item></Link>
                                                                                                }
                                                                                                {
                                                                                                    (store?.permissions?.includes('record-returns') || override) &&
                                                                                                    <Menu.Item onClick={ () => returns(rec) }>Record Returns</Menu.Item>
                                                                                                }
                                                                                                {
                                                                                                    (store?.permissions?.includes('record-spoilage-damage') || override) &&
                                                                                                    <Menu.Item onClick={ () => spoilage(rec) }>Record Spoilage/Damage</Menu.Item>
                                                                                                }
                                                                                                {
                                                                                                    (store?.permissions?.includes('issue-to-self') || override) &&
                                                                                                    <Menu.Item onClick={ () => issueToSelf(rec) }>Issue to Self</Menu.Item>
                                                                                                }
                                                                                            </> : null
                                                                                        }
                                                                                    </Menu>
                                                                                }>
                                                                                <button className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></button>
                                                                            </Dropdown>
                                                                        </td>
                                                                    </tr>
                                                                )})
                                                            }
                                                        </tbody>
                                                    </table>
                                                    :
                                                    <div className="w-full h-16 flex items-center justify-center">
                                                        <p className="font-semibold text-base">No items were found</p>
                                                    </div>
                                            }
                                        </Receive>
                                        {Paginate}
                                    </div>
                                    :
                                    <div className="w-full h-16 flex items-center justify-center">
                                        <p className="font-semibold text-base">Please select a store</p>
                                    </div>
                            }
                        </Receive>
                    </div>
                </div>
                <Switch>
                    <Route path={`${path}/history/:id/:store`}>
                        <ItemHistory path={path} onClose={refresh} />
                    </Route>
                    <Route path={`${path}/movement/:id/:store`}>
                        <Movement path={path} onClose={refresh} />
                    </Route>
                    <Route path={`${path}/requests/:id`}>
                        <ItemRequests path={path} />
                    </Route>
                </Switch>
            </div>
        </div>
    )
}

export default Inventory
